import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLID,
  GraphQLString
} from 'graphql'
import { Context } from '../shared'
import { vulnerabilitySinkGroupType } from '../types/vulnerability-sink-group'
export interface VulnerabilityOrSinkGroupQueryArgs {
  readonly organizationUuid: string
  readonly vulnerabilityOrSinkGroupId: string
}

export const VulnerabilityOrSinkGroupQueryType = {
  organizationUuid: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  vulnerabilityOrSinkGroupId: {
    description:
      'The unique id for the vulnerability or sink group being queried',
    type: new GraphQLNonNull(GraphQLString)
  }
}

// Used to pull exisitng VulnerabilityOrSinkGroups from apollo cache. Does not make an API request.
export const vulnerabilityOrSinkGroup: GraphQLFieldConfig<
  any,
  Context,
  VulnerabilityOrSinkGroupQueryArgs
> = {
  description:
    'Fake query to pull exisitng VulnerabilityOrSinkGroups from apollo cache',
  type: new GraphQLNonNull(vulnerabilitySinkGroupType),
  args: VulnerabilityOrSinkGroupQueryType
}
